import { Component, Input, OnInit } from '@angular/core';
import { AppVersionService } from '@shared/services/app-version.service';
import { AppService } from '@shared/services/app.service';

@Component({
  selector: 'app-application-update-required',
  templateUrl: './application-update-required.component.html',
  styleUrls: ['./application-update-required.component.scss']
})
export class ApplicationUpdateRequiredComponent implements OnInit {
  @Input() params: {force: boolean};

  constructor(
    private appVersionService: AppVersionService
  ) { }

  ngOnInit(): void {
  }

  reloadPage() {
    location.reload();
  }

  cancel() {
    this.appVersionService.declineUpdateSuggestion()
  }
}
